export const fr = {
  'app.name': 'La Gazette',
  'app.tagline': 'Le journal à scandale dont vous êtes les victimes.',
  'lang.switch': 'English',
  'lang.label': 'Changer de langue',
  'sound.mute': 'Couper le son',
  'sound.unmute': 'Activer le son',
  'connection.lost': 'Connexion perdue. Reconnexion en cours…',

  'home.name.label': 'Votre nom',
  'home.name.placeholder': 'Prénom ou surnom',
  'home.create': 'Ouvrir une enquête',
  'home.or': 'ou rejoindre un dossier',
  'home.code.label': 'Code du dossier',
  'home.join': 'Rejoindre',
  'home.name.required': 'Écrivez votre nom pour ouvrir le dossier.',
  'home.code.required': 'Le code du dossier fait quatre lettres.',
  'home.joinInvite': 'Rejoindre le dossier {code}',
  'home.createInstead': 'Ouvrir plutôt une nouvelle enquête',
  'home.rules.title': 'Comment se déroule l’enquête',
  'home.rules.1': 'Confessions : chacun répond en secret à quelques questions sur lui-même.',
  'home.rules.2': 'Rédaction : vous lisez les confessions de deux suspects, écrivez une rumeur vraie tirée de l’une d’elles, puis une fausse sur qui vous voulez.',
  'home.rules.3': 'Publication : La Gazette paraît sur tous les écrans.',
  'home.rules.4': 'Enquête : pour chaque rumeur, vraie ou fausse, et qui l’a écrite ? La victime ne vote pas et a le droit de mentir.',
  'home.rules.5': 'Révélation : le tampon tombe, la plume est démasquée. On marque en bluffant et en déduisant.',
  'home.rules.players': 'De 4 à 10 joueurs, chacun sur son téléphone. Environ 20 minutes.',
  'home.sample.headline': 'Thomas aurait pleuré devant Ratatouille au cinéma, en 2023',
  'home.sample.subtitle': 'Nos sources affirment qu’il a prétexté une allergie au pop-corn.',

  'error.ROOM_NOT_FOUND': 'Aucun dossier ne porte ce code.',
  'error.ROOM_FULL': 'Ce dossier est complet.',
  'error.GAME_IN_PROGRESS': 'L’enquête a déjà commencé sans vous.',
  'error.NAME_INVALID': 'Il nous faut un nom, 20 caractères au plus.',
  'error.NAME_TAKEN': 'Quelqu’un porte déjà ce nom dans le dossier.',
  'error.SESSION_INVALID': 'Votre place dans ce dossier a expiré.',
  'error.NOT_HOST': 'Seul l’hôte peut faire ça.',
  'error.WRONG_PHASE': 'Trop tard : l’enquête est passée à l’étape suivante.',
  'error.NOT_ENOUGH_PLAYERS': 'Il faut au moins 4 suspects pour ouvrir l’enquête.',
  'error.ADULTS_REQUIRED': 'Confirmez que tout le monde est majeur pour cette intensité.',
  'error.BOTS_DISABLED': 'Les suspects fictifs sont désactivés sur ce serveur.',
  'error.INVALID_INPUT': 'Cette saisie n’a pas été acceptée.',
  'error.RATE_LIMITED': 'Doucement ! Réessayez dans un instant.',
  'error.NETWORK': 'Serveur injoignable. Vérifiez votre connexion et réessayez.',
  'error.KICKED': 'L’hôte vous a retiré du dossier.',

  'lobby.case': 'Dossier',
  'lobby.share': 'Partager le lien',
  'lobby.copied': 'Lien copié',
  'lobby.qr.show': 'Afficher le QR code',
  'lobby.qr.hide': 'Masquer le QR code',
  'lobby.qr.alt': 'QR code pour rejoindre le dossier {code}',
  'lobby.lanHint': 'Page ouverte en localhost : pour les téléphones, lancez le serveur avec PUBLIC_URL réglé sur l’adresse IP de cette machine.',
  'lobby.suspects': 'Suspects',
  'lobby.you': 'vous',
  'lobby.host': 'hôte',
  'lobby.bot': 'fictif',
  'lobby.offline': 'hors ligne',
  'lobby.kick': 'Retirer {name}',
  'lobby.reroll': 'Changer de portrait',
  'lobby.addBot': 'Ajouter un suspect fictif',
  'lobby.need.one': 'Encore {n} suspect avant d’ouvrir l’enquête.',
  'lobby.need.other': 'Encore {n} suspects avant d’ouvrir l’enquête.',
  'lobby.start': 'Lancer l’enquête',
  'lobby.waitHost': '{name} lancera l’enquête.',

  'settings.title': 'Réglages',
  'settings.readonly': 'Réglages choisis par l’hôte',
  'settings.intensity': 'Intensité',
  'settings.intensity.soft': 'Soft',
  'settings.intensity.spicy': 'Épicé',
  'settings.intensity.unfiltered': 'Sans filtre',
  'settings.intensity.help.soft': 'Questions légères, parfaites entre collègues.',
  'settings.intensity.help.spicy': 'Plus personnel. Réservé aux adultes.',
  'settings.intensity.help.unfiltered': 'Rien n’est interdit. Réservé aux adultes.',
  'settings.adults': 'Tous les joueurs ont 18 ans ou plus',
  'settings.questions': 'Questions par joueur',
  'settings.pace': 'Rythme',
  'settings.pace.relaxed': 'Détendu',
  'settings.pace.normal': 'Normal',
  'settings.pace.fast': 'Rapide',
  'settings.corbeau': 'Variante « Le Corbeau »',
  'settings.corbeau.help': 'Un joueur secret n’écrit que des rumeurs fausses. S’il n’est jamais démasqué, il gagne 5 points.',
  'settings.typography': 'Typographie uniformisée',
  'settings.typography.help': 'Ponctuation, guillemets et majuscules harmonisés : personne n’est trahi par sa façon d’écrire.',
  'settings.on': 'activée',
  'settings.off': 'désactivée',

  'phase.confessions': 'Confessions',
  'phase.writing': 'Rédaction',
  'phase.publication': 'Publication',
  'phase.investigation': 'Enquête',
  'phase.reveal': 'Révélation',
  'phase.plume': 'Plume d’or',
  'phase.final': 'Palmarès',
  'timer.label': 'Temps restant',

  'conf.title': 'Votre déposition',
  'conf.intro': 'Répondez en secret. Deux autres suspects liront vos réponses pour en tirer une rumeur vraie, sans que personne sache lesquels.',
  'conf.placeholder': 'Votre réponse…',
  'conf.sign': 'Signer ma déposition',
  'conf.signed': 'Déposition signée',
  'conf.edit': 'Modifier ma déposition',
  'conf.needOne': 'Répondez au moins à une question avant de signer.',
  'progress.signed': '{done} sur {total} ont signé',

  'write.intro': 'Vous avez reçu les dépositions de {names}. Personne ne sait que vous les avez lues.',
  'write.noSources': 'Personne ne s’est confessé : vous écrirez deux rumeurs fausses.',
  'write.corbeau.title': 'Vous êtes le Corbeau',
  'write.corbeau.body': 'Écrivez deux rumeurs fausses. Si personne ne vous démasque jamais, vous gagnez 5 points.',
  'write.sources': 'Pièces reçues',
  'write.use': 'Utiliser cette pièce',
  'write.used': 'Pièce retenue',
  'write.true.title': 'Rumeur vraie',
  'write.true.help': 'Choisissez une pièce ci-dessus, puis reformulez-la façon presse à scandale.',
  'write.false.title': 'Rumeur fausse',
  'write.false.help': 'Inventez de toutes pièces, sur la victime de votre choix.',
  'write.victim': 'Victime',
  'write.kicker': 'Rubrique',
  'write.headline': 'Gros titre',
  'write.headline.placeholder': 'On a vu…',
  'write.subtitle': 'Chapeau, facultatif',
  'write.subtitle.placeholder': 'Nos sources affirment que…',
  'write.templates': 'Rumeurs à trous',
  'write.invent': 'Aide-moi à inventer',
  'write.send': 'Envoyer à la rédaction',
  'write.sent': 'Rumeurs envoyées à la rédaction',
  'write.edit': 'Modifier mes rumeurs',
  'write.missing.source': 'Choisissez une pièce.',
  'write.missing.victim': 'Choisissez une victime.',
  'write.missing.headline': 'Le gros titre doit faire au moins 8 caractères.',
  'write.chars': '{n} / {max}',
  'progress.sent': '{done} sur {total} ont envoyé',

  'kicker.exclusive': 'Exclusif',
  'kicker.scandal': 'Scandale',
  'kicker.revelations': 'Révélations',
  'kicker.spotted': 'On l’a vu',
  'kicker.indiscretion': 'Indiscrétion',
  'kicker.breaking': 'Dernière minute',

  'pub.title': 'La Gazette est parue',
  'pub.count.one': '{n} rumeur à la une',
  'pub.count.other': '{n} rumeurs à la une',
  'pub.read': 'Lire la gazette',
  'pub.close': 'Refermer la gazette',
  'pub.start': 'Ouvrir l’enquête',
  'pub.waitHost': 'L’enquête s’ouvre dans un instant.',

  'inv.case': 'Affaire {n} sur {total}',
  'inv.concerns': 'Concerne {name}',
  'inv.truth': 'Vrai ou faux ?',
  'inv.true': 'Vrai',
  'inv.or': 'ou',
  'inv.false': 'Faux',
  'inv.author': 'Qui l’a écrite ?',
  'inv.accuse': 'Accuser {name}',
  'inv.victim.title': 'C’est sur vous.',
  'inv.victim.body': 'Vous seul connaissez la vérité, et vous avez le droit de mentir : chaque enquêteur trompé vous rapporte 1 point.',
  'inv.victim.react': 'Réagir publiquement',
  'inv.author.note': 'C’est votre rumeur. Votez quand même pour brouiller les pistes : votre bulletin ne compte pas.',
  'inv.reaction': 'déclare {name}',
  'progress.voted': '{done} sur {total} bulletins',

  'reaction.deny': 'C’est faux !',
  'reaction.nocomment': 'Aucun commentaire.',
  'reaction.confess': 'Bon… c’est vrai.',
  'reaction.lawyer': 'J’appelle mon avocat.',
  'reaction.nonsense': 'N’importe quoi !',
  'reaction.never': 'Vous ne saurez jamais.',

  'rev.true': 'Vrai',
  'rev.false': 'Faux',
  'rev.author.stamp': 'Auteur',
  'rev.fooled.none': 'Personne n’a été trompé.',
  'rev.fooled.one': '{n} enquêteur trompé',
  'rev.fooled.other': '{n} enquêteurs trompés',
  'rev.found': 'Plume identifiée par {names}',
  'rev.hidden': 'Personne n’a identifié la plume.',
  'rev.points': 'Points de l’affaire',
  'rev.noPoints': 'Aucun point sur cette affaire.',
  'rev.next': 'Affaire suivante',
  'rev.toPlume': 'Passer à la plume d’or',
  'rev.toResults': 'Voir le palmarès',
  'reason.truth': 'vrai ou faux trouvé',
  'reason.author-found': 'plume identifiée',
  'reason.fooled': 'enquêteurs trompés',
  'reason.undetected': 'jamais démasqué',
  'reason.victim-bluff': 'bluff de la victime',
  'reason.corbeau': 'Corbeau jamais démasqué',

  'plume.title': 'La plume d’or',
  'plume.body': 'Votez pour le meilleur gros titre de la soirée. Un honneur, zéro point.',
  'plume.own': 'Votre article',
  'plume.vote': 'Décerner la plume à cet article',
  'plume.voted': 'Plume décernée',
  'progress.plume': '{done} sur {total} ont voté',

  'final.title': 'Palmarès',
  'final.points': '{n} pts',
  'final.rank': '{n}e',
  'final.rank.first': '1er',
  'final.empty': 'Aucune rumeur n’a été publiée. La rédaction a pris sa soirée.',
  'final.corbeau': 'Le Corbeau était {name}.',
  'final.download': 'Télécharger la gazette',
  'final.share': 'Partager la gazette',
  'final.shareText': 'Notre gazette de la soirée',
  'final.restart': 'Nouvelle enquête',
  'final.leave': 'Quitter le dossier',
  'final.leave.confirm': 'Confirmer : quitter',
  'final.waitHost': '{name} peut lancer une nouvelle enquête.',
  'title.plume': 'Plume d’or',
  'title.plume.help': 'Meilleur gros titre, élu par le groupe',
  'title.sleuth': 'Fin limier',
  'title.sleuth.help': 'A identifié le plus de plumes',
  'title.bluffer': 'As du bluff',
  'title.bluffer.help': 'A le mieux menti en victime',
  'title.viper': 'Langue de vipère',
  'title.viper.help': 'A le plus trompé en auteur',
  'title.corbeau-escaped': 'Le Corbeau s’est envolé',
  'title.corbeau-escaped.help': '5 points, jamais démasqué',
  'title.corbeau-caught': 'Le Corbeau démasqué',
  'title.corbeau-caught.help': 'Pris la plume dans le sac',

  'menu.leave': 'Quitter le dossier',
  'menu.leave.confirm': 'Confirmer : quitter',

  'gz.motto': 'Journal de la haute société et des bas instincts',
  'gz.edition': 'Nº\u00A0{n}',
  'gz.price': 'Prix : un secret',
  'gz.count.one': '{n} rumeur',
  'gz.count.other': '{n} rumeurs',
  'gz.concerns': 'Concerne {name}',
  'gz.signed': 'Signé {name}',
  'gz.palmares': 'Palmarès de la soirée',
  'gz.footer': 'La Gazette, le jeu où vous faites la une',
  'gz.ad.1': 'ÉLIXIR DU DOCTEUR POTIN. Guérit la curiosité en trois gouttes. Effet secondaire : la curiosité.',
  'gz.ad.2': 'PERDU : réputation. Forte récompense à qui la rapportera en bon état.',
  'gz.ad.3': 'COURS DE BLUFF PAR CORRESPONDANCE. Première leçon gratuite. Les suivantes aussi, croyez-nous.',
  'gz.ad.4': 'PLUMES ANONYMES livrées sous pli discret. Discrétion garantie, ou presque.',
  'gz.ad.5': 'ON RECHERCHE des témoins de la soirée d’hier. Ne se présenter sous aucun prétexte.',
  'fiche.number': 'Fiche nº\u00A0{n}',
  'fiche.m1': 'Taille',
  'fiche.m2': 'Envergure',
  'fiche.m3': 'Tête, long.',
  'fiche.m4': 'Tête, larg.',
  'fiche.m5': 'Oreille dr.',
  'fiche.name': 'Nom',
  'fiche.case': 'Dossier {code}',
} as const;

export type MessageKey = keyof typeof fr;
